export default __webpack_public_path__ + "static/media/no-item.b0776348.png";